<template>
  <div class="flex flex-col">

    <file-uploader class="w-full"
      :model="model"
      :id="id"
      :isLesson="isLesson"
      v-show="uploading"
      @close="$emit('close')"/>

  </div>
</template>

<script>
import FileUploader from './FileUploader.vue';

export default {
  provide() {
    return {
      imageUploaderState: this.sharedState,
    };
  },

  components: { FileUploader },

  props: ['model', 'id', 'isLesson'],

  data() {
    return {
      uploading: true,
      sharedState: {
        uploaded: false,
      },
    };
  },

  methods: {
    resetManager() {
      this.uploading = false;
      this.sharedState.uploaded = false;
      this.$emit('reset-me');
    },
  },

};
</script>

<style scoped>

</style>
